module.exports = __webpack_public_path__ + "img/burshtat_b2b_portfolio_5_mob_2x.797cecb8.png";